import { useEffect, useRef, useState } from 'react';
import ISRReportModalContent from './ISRReportModalContent';
import { scheduleRender } from '@features/analysis/rendering/Panels/renderState';
import useModalActions from '@hooks/common/useModalAction';
import { useConfig } from 'config/useConfig';
import BaseModalContent from '../BaseReportModalContent/BaseReportModalContetnt';
import { useReportModal } from '@hooks/useReportModal';
import { ISRItem } from './ISR.types';
import { useBufferPool } from '@features/analysis/rendering/Panels/Renderers/vtkManagers';
import { useBrowserPage } from '@features/browser/useBrowserPage';
import { useAnalysisPage } from '@features/analysis/useAnalysisPage';
import { usePanelContainer } from '@features/analysis/rendering/Panels/usePanelContainer';
import useAuth from '@hooks/Auth/useAuth';
import { getConfiguredCprCrossSectionImageMode } from '@features/analysis/rendering/Panels/cprImageModeConfig';
import { captureServerIsrReportImages } from '../serverCprReportCapture';

const ISRReportModal = ({ onClose }: { onClose: () => void }) => {
  const [imageSrc, setImageSrc] = useState<
    Record<number, { fullCpr?: string; stent?: string }>
  >({});

  const { waitingAction, closeLoadingModal } = useModalActions();
  const { config } = useConfig();
  const { contextPool, bufferPool } = useBufferPool();
  const { selectedSeriesId } = useBrowserPage();
  const { currentVOI } = useAnalysisPage();
  const { analysisType } = usePanelContainer();
  const { accessToken } = useAuth();
  const poolRef = useRef(contextPool);
  useEffect(() => {
    poolRef.current = contextPool;
  }, [contextPool]);

  let reportdata: ISRItem[] = [];
  let reportBranchData: any[] = [];
  const isrdata = config.isr_data;
  if (!isrdata) return;

  isrdata.forEach((val) => {
    const data = Array.from(val.values());
    data.forEach((v) => {
      v.branchid;
      reportdata.push({
        branch: v.name,
        lengthMm: v.length,
        isr: v.isr === 'True' ? '≥ 50%' : '≤ 50%',
        images: imageSrc?.[reportdata.length],
      });
      reportBranchData.push({
        branchid: v.branchid,
        index: v.index,
      });
    });
  });

  const setter = async (
    key: number,
    results: Record<string, Promise<string>>,
  ) => {
    const resultEntries = await Promise.all(
      Object.entries(results).map(async ([key, promise]) => {
        const img = await promise;
        return [key, img];
      }),
    );
    const index = captureCount;
    setImageSrc((prev) => ({
      ...prev,
      [index]: {
        ...(prev[index] || {}),
        ...Object.fromEntries(resultEntries),
      },
    }));
  };

  const captureCount = Object.keys(imageSrc).length;
  const beNext = captureCount === 0 || captureCount !== 0;
  const isDone = captureCount >= reportdata.length;

  useEffect(() => {
    waitingAction({ message: 'Waiting' });
  }, []);

  useEffect(() => {
    if (!isDone) {
      if (beNext) {
        console.log('쏜다');

        // const con = {
        //   current: poolRef.current[
        //     `CPR.0.straightened` as ContextKey
        //   ] as CPRContext,
        // } as React.MutableRefObject<CPRContext | null>;

        const scheduleLegacyIsrCapture = () => {
          const currentReport = reportBranchData[captureCount];
          if (!currentReport) return;
          scheduleRender(`CPR.0.straightened`, {
            type: 'captureISR',
            key: currentReport.branchid,
            branchIndex: currentReport.index,
            keys: ['fullCpr', 'stent'],
            setter,
          });
        };

        if (getConfiguredCprCrossSectionImageMode() === 'server') {
          const currentReport = reportBranchData[captureCount];
          const pool = selectedSeriesId ? bufferPool[selectedSeriesId] : undefined;
          if (pool && currentReport) {
            captureServerIsrReportImages({
              accessToken,
              seriesId: selectedSeriesId,
              pool,
              analysisType,
              currentVOI,
              branchId: currentReport.branchid,
              indexRange: currentReport.index,
            })
              .then((result) => {
                if (!result) {
                  throw new Error('server ISR CPR capture returned no image');
                }
                setImageSrc((prev) => ({
                  ...prev,
                  [captureCount]: result,
                }));
              })
              .catch((err) => {
                console.warn('[report][front_data] ISR CPR capture failed, fallback to legacy scheduleRender', err);
                scheduleLegacyIsrCapture();
              });
          } else {
            scheduleLegacyIsrCapture();
          }
        } else {
          scheduleLegacyIsrCapture();
        }
      }
    } else {
      closeLoadingModal();
      scheduleRender('MarkerLine.0.straightened', { type: 'captureDone' });
    }
  }, [
    accessToken,
    analysisType,
    beNext,
    bufferPool,
    captureCount,
    currentVOI,
    isDone,
    selectedSeriesId,
  ]);

  if (!isDone) {
    return null;
  }

  return (
    <BaseModalContent
      className='isr'
      onClose={onClose}
      title="In-Stent Restenosis Analysis Report"
      capturebutton={reportdata.length > 0}

      // vw={50}
      // vh={80}
    >
      <ISRReportModalContent data={reportdata} />
    </BaseModalContent>
  );
};

export function useISRReportModal(res:{updateActivatedTool: (tool: any,check: boolean) => void}) {
  return useReportModal({Component:ISRReportModal,...res});
}
